import useInitialize from "./useInitialize";
import useExecute from "./useExecute";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import { TestEmailContext } from "./TestEmailContext";

function useTestEmailAction(index: any): any {
  const initialize = useInitialize();
  const initializeFunction = (id: number) => initialize(id);

  const onSuccessExecute = () => {
    setShowModal(false);
    index();
  };

  const execute = useExecute();

  const executeFunction = () => execute(onSuccessExecute);

  const { setShowModal } = useContext(TestEmailContext);

  const modalConfig = {
    context: TestEmailContext,
    title: t("test_email"),
    onSubmit: () => executeFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t("are_you_sure_you_want_to_test_this_email?")}
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    initializeFunction,
    actionTemplate,
  };
}

export default useTestEmailAction;
